module.exports = __webpack_public_path__ + "static/media/notification-icon.920f8d78.png";